import { render } from "./LandscapeView.vue?vue&type=template&id=c8afa942&scoped=true&lang=html"
import script from "./LandscapeView.vue?vue&type=script&lang=js"
export * from "./LandscapeView.vue?vue&type=script&lang=js"

import "./LandscapeView.vue?vue&type=style&index=0&id=c8afa942&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dlin\\Desktop\\work\\webportal-lms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8afa942"]])

export default __exports__